import {apiRequest, ApiResponse} from "@/data/api/portal"

export interface Firewall {
  app: string;
  rules: string;
}

export async function getFirewalls(env: string): Promise<ApiResponse<Firewall[]>> {
  return apiRequest("/firewalls", {params: {env}})
}

export async function setFirewalls(env: string, items: Firewall[]): Promise<ApiResponse<string>> {
  return apiRequest("/firewalls", {env, items}, "post")
}
